import {
  type PageContainerVariants,
  pageContainerVariants,
} from "../../styles/utils"
import { classNames } from "../../utils"
import { Block, type BlockProps } from "../Block"

export type ContainerProps = Omit<BlockProps, "padding"> & PageContainerVariants

/**
 * A centered container for a page with a max width.
 */
export function Container({ className, padding, ...rest }: ContainerProps) {
  return (
    <Block
      className={classNames(pageContainerVariants({ padding }), className)}
      {...rest}
    />
  )
}
